var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-message"},[_c('span',{staticClass:"message-all"},[_vm._v(_vm._s(_vm.warningMessage))]),_c('div',{staticClass:"link-href",on:{"click":_vm.onCopyTraceId}},[_c('span',{staticClass:"link-href-traceId"},[_vm._v(_vm._s(_vm.traceId))]),_c('i',{staticClass:"el-icon-copy-document link-href-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }